/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 *                imgix constants
 */

export const DEFAULT_OPTIONS = {
  auto: 'format', // http://www.imgix.com/docs/reference/automatic#param-auto
}

export const IMGIX_OPTIONS = new Set([
  'bri',
  'con',
  'exp',
  'gam',
  'high',
  'hue',
  'invert',
  'sat',
  'shad',
  'sharp',
  'usm',
  'usmrad',
  'vib',
  'auto',
  'ba',
  'balph',
  'bc',
  'bf',
  'bh',
  'blend',
  'bm',
  'bp',
  'bs',
  'bw',
  'bx',
  'by',
  'border-radius-inner',
  'border-radius',
  'border',
  'pad',
  'colors',
  'palette',
  'prefix',
  'faceindex',
  'facepad',
  'faces',
  'bg',
  'fill-color',
  'fill',
  'fp-debug',
  'fp-x',
  'fp-y',
  'fp-z',
  'ch',
  'chromasub',
  'colorquant',
  'cs',
  'dl',
  'dpi',
  'fm',
  'lossless',
  'q',
  'corner-radius',
  'mask',
  'maskbg',
  'nr',
  'nrs',
  'page',
  'dpr',
  'flip',
  'or',
  'rot',
  'crop',
  'fit',
  'h',
  'max-h',
  'max-w',
  'min-h',
  'min-w',
  'rect',
  'w',
  'blur',
  'htn',
  'mono',
  'px',
  'sepia',
  'txt',
  'txtalign',
  'txtclip',
  'txtclr',
  'txtfit',
  'txtfont',
  'txtlig',
  'txtline',
  'txtlineclr',
  'txtpad',
  'txtshad',
  'txtsize',
  'txtwidth',
  'trim',
  'trimcolor',
  'trimmd',
  'trimsd',
  'trimtol',
  'txtlead',
  'txttrack',
  '~text',
  'mark',
  'markalign',
  'markalpha',
  'markbase',
  'markfit',
  'markh',
  'markpad',
  'markscale',
  'markw',
  'markx',
  'marky',
])
